module.exports = __webpack_public_path__ + "static/ImportAttrs-fbd4b0564c7b914abf5136835c12bdf8.png";